var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"lds-wrapper",class:{
    abs: _vm.props.abs,
    container: _vm.props.container,
    info: _vm.props.info,
    small: _vm.props.small,
    transparent: _vm.props.transparent,
  }},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])}]

export { render, staticRenderFns }